import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'two-press-button',
  templateUrl: './two-press-button.component.html',
  styleUrls: ['./two-press-button.component.scss']
})
export class TwoPressButtonComponent implements OnInit {

  @Input()
  buttonClass = 'fas fa-trash';

  @Output()
  clicked = new EventEmitter();

  showConfirm = false;

  constructor() { }

  ngOnInit() {
  }

  confirm() {
    this.clicked.emit();
    this.showConfirm = false;
  }

  cancel() {
    this.showConfirm = false;
  }
}
